class HelpController {
    constructor($scope,$state) {
        "ngInject";

        this.tabs = [
            {
                name: '版权相关',
                click: () => {
                    $state.go('app.page.help.copyright');
                },
                active: $state.is('app.page.help.copyright')
            },
            {
                name: '原本知识点',
                click: () => {
                    $state.go('app.page.help.knowledge');
                },
                active: $state.is('app.page.help.knowledge')
            },
            {
                name: '帮助中心',
                click: () => {
                    $state.go('app.page.help.guide');
                },
                active: $state.is('app.page.help.guide')
            }
        ];
    }

}

export default HelpController;



// WEBPACK FOOTER //
// ./src/app/components/page/help/help.controller.js